module.exports = __webpack_public_path__ + "img/logout.4c756a1d.svg";